import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';
import mockData from '../mock';

const HeroSection = ({ onCtaClick }) => {
  const { hero } = mockData;

  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1655300256335-beef51a914fe)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 to-blue-800/90"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white space-y-8 animate-fade-in">
            {/* Badge */}
            <div className="inline-flex items-center space-x-2 bg-orange-500/20 backdrop-blur-sm border border-orange-400 rounded-full px-4 py-2">
              <CheckCircle2 className="w-5 h-5 text-orange-400" />
              <span className="text-sm font-semibold text-orange-300">Now Available in Odisha</span>
            </div>

            {/* Headline */}
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight">
              {hero.headline}
            </h1>

            {/* Sub-headline */}
            <p className="text-lg md:text-2xl text-blue-100 font-medium">
              {hero.subHeadline}
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={() => {
                  // Track CTA click
                  if (window.fbq) {
                    window.fbq('trackCustom', 'CTAClick', {
                      button_name: 'Get Solar Estimate',
                      button_location: 'Hero Section'
                    });
                  }
                  onCtaClick();
                }}
                size="lg"
                className="bg-orange-500 hover:bg-orange-600 text-white text-base md:text-lg px-6 md:px-8 py-5 md:py-6 rounded-lg shadow-2xl animate-pulse-subtle w-full sm:w-auto"
              >
                {hero.ctaPrimary}
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button
                onClick={() => {
                  // Track secondary CTA click
                  if (window.fbq) {
                    window.fbq('trackCustom', 'CTAClick', {
                      button_name: 'Check Subsidy',
                      button_location: 'Hero Section'
                    });
                  }
                  onCtaClick();
                }}
                size="lg"
                variant="outline"
                className="bg-white/10 backdrop-blur-sm text-white border-2 border-white hover:bg-white hover:text-blue-900 text-base md:text-lg px-6 md:px-8 py-5 md:py-6 rounded-lg w-full sm:w-auto"
              >
                {hero.ctaSecondary}
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center space-x-4 pt-4">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-400 to-yellow-400 border-2 border-white flex items-center justify-center text-white font-bold"
                  >
                    {i}
                  </div>
                ))}
              </div>
              <div>
                <p className="text-sm text-blue-200">Trusted by 500+ homes</p>
                <div className="flex items-center space-x-1">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span key={star} className="text-yellow-400 text-lg">★</span>
                  ))}
                  <span className="text-sm text-blue-200 ml-2">(4.9/5)</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Stats */}
          <div className="grid grid-cols-2 gap-4">
            {hero.stats.map((stat, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 card-hover"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <h3 className="text-3xl md:text-4xl font-bold text-orange-400 mb-2">
                  {stat.value}
                </h3>
                <p className="text-blue-100 font-medium">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
};

export default HeroSection;